import { useEffect } from 'react'
import { useModalStack } from '../context/modalStackContext'
import AppSwitcherModal from '../components/appSwitcher/AppSwitcherModal'

function useGlobalShortcuts() {
  const { pushModal, stack } = useModalStack()

  useEffect(() => {
    const handleKeyDown = (e) => {
      const isCtrlK = (e.ctrlKey || e.metaKey) && e.key === 'k'
      if (!isCtrlK) return

      e.preventDefault()

      // Do not stack a second switcher on top of an already-open modal
      if (stack.length > 0) return

      pushModal(AppSwitcherModal)
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [pushModal, stack.length])
}

export default useGlobalShortcuts
